<template>
  <div class="sky-step-view-create-order-wrapper">
    <div style="padding-top: 50px;text-align: center; float: left; position: absolute;" class="wsp-display-flex">
      <div
        style="width: 6px;
          line-height: 28px;
          background-color: #0052d9;"
      ></div>
      <div
        style="font-size: 18px;
          line-height: 28px;
          padding-left: 12px;"
      >
        售前测试方案
      </div>
    </div>
    <div class="order-download wsp-display-flex-center" style="height: 100%;">
      <div>
        <!-- <div class="wsp-icon-word font-size-24 bg-3bb113"></div> -->

        <div class="order-result text font-color" style="font-weight: bolder;" v-if="industryCode === 'YYS'">
          因场景不成熟，平台无法自动生成售前测试方案。请根据以下链接手动生成方案（方案指导可联系李英杰），并到样机系统进行上传
        </div>
        <div class="order-result text">请点击下方链接</div>
        <div class="wsp-icon-word font-size-24 bg-3bb113" v-if="industryCode === 'YYS'" @click="downloadDocument">
          <a>运营商售前测试指导书</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { PLAN_MNG } from '@/api/apiModules'

export default {
  name: 'StepViewCreateOrederIndustry',
  components: {
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    data: {
      type: Object,
      default() {
        return null
      }
    }
  },
  mounted() {
    this.$emit('openChangeDialog', { projectId: this.data.projectId })
    this.industryCode = this.data.industryCode
  },
  created() {
    this.$emit('showBtns', {
      preStep: true,
      nextStep: false,
      saveStep: false,
      enableTabChange: false
    })
  },
  data: function() {
    return {
      projectCustomer: '',
      industryCode: null,
      buildStatus: 'pending',
      canDownload: false,
      serverTopology: [],
      sceneTopology: [],
      topologyNodes: [],
      topologyEdges: []
    }
  },
  methods: {
    getData() {
      return {}
    },

    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
      return true
    },
    downloadDocument() {
      if (this.industryCode === 'YYS') {
        window.open('https://ruijie.feishu.cn/sheets/LejrskSi6hZe69ttaiXcBQCAnFb', '_blank')
      }
    },
    downloadExcel() {
      this.$store.dispatch('customDownloadDocument', {
        module: PLAN_MNG,
        params: {
          id: this.data.projectId
        },
        action: 'downloadPlanExcel'
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-create-order-wrapper) {
  height: 100%;
  .order-topology {
    display: flex;
    margin-top: 36px;
    justify-content: center;
    text-align: center;
    .view-page {
      width: 90%;
      height: 60vh;
    }
  }

  .order-download {
    display: flex;
    justify-content: center;
    text-align: center;
    .order-icon {
      display: flex;
      .wsp-icon-status-success {
        color: #3bb113;
      }
      .wsp-icon-status-pending {
        color: #e69d01;
      }
      .wsp-icon-status-error {
        color: #ec2805;
      }
      .wsp-icon {
        font-size: 28px;
        padding: 0 12px;
        text-align: right;
      }
      .order-status {
        line-height: 28px;
      }
    }
    .text {
      line-height: 28px;
    }
    .font-color {
      color: #ec2805;
    }
  }
}
</style>
